import React from "react";
import { Stack } from "@mui/material";
import { QueryAction } from "../../../common/FiltersFormEngine/queryReducer";
import { FilterItem } from "../../../common/FiltersFormEngine/types";
import { useFiltersRegistry } from "../../../context/FiltersProvider";
import { FilterContexType } from "../../layout/ViewHeader";
import FilterGroup from "./components/FilterGroup";

type Props = {
	filterContext?: FilterContexType;
	items?: FilterItem[];
	dispatch?: React.Dispatch<QueryAction>;
	readOnly?: boolean;
};

const AdvancedFiltersModal = ({ filterContext, items, dispatch, readOnly }: Props) => {
	const { advancedForm, dispatchAdvancedForm } = useFiltersRegistry();

	const resolvedItems = items ?? advancedForm;
	const resolvedDispatch = dispatch ?? dispatchAdvancedForm;

	return (
		<Stack spacing={1} width="100%">
			{resolvedItems.map((item) =>
				item.type === "group" ? (
					<FilterGroup
						key={item.value.id}
						group={item.value}
						filterContext={filterContext}
						dispatch={resolvedDispatch}
						readOnly={readOnly}
					/>
				) : null
			)}
		</Stack>
	);
};

export default AdvancedFiltersModal;
